export default `
clip-path: polygon(50% 0%, 0% 100%, 100% 100%);
`
